module.exports = __webpack_public_path__ + "img/digitalEvaluationBanner.a0db5060.jpg";